((w, d) => {

    const items = d.querySelectorAll('.MainNav__item');

    function closeSubMenu(button, linkbutton) {
        linkbutton.classList.remove('MainNav__link-button--active');
        button.classList.remove('MainNav__button--active');
        button.setAttribute('aria-expanded', false);
    }

    items.forEach((item) => {
        const linkbutton = item.querySelector('.MainNav__link-button');

        item.addEventListener('focusout', (e) => {
            const mobile = w.innerWidth <= 1400;
            const button = item.querySelector('.MainNav__button[aria-expanded=true]');
            if (e.relatedTarget) {
                if (!item.contains(e.relatedTarget) && button && !mobile) {
                    closeSubMenu(button, linkbutton);
                }
            }
        });

        d.addEventListener('click', (e) => {
            const button = item.querySelector('.MainNav__button[aria-expanded=true]');
            const mobile = w.innerWidth <= 1400;
            if (!item.contains(e.target) && button && !mobile) {
                closeSubMenu(button, linkbutton);
            }
        });

        d.addEventListener('keydown', (e) => {
            const button = item.querySelector('.MainNav__button[aria-expanded=true]');
            if (e.key === 'Escape' && button) {
                closeSubMenu(button, linkbutton);
                button.focus();
            }
        });
    });

    const subbuttons = d.querySelectorAll('.SubNavL1__button');

    if (subbuttons) {
        subbuttons.forEach((button) => {
            button.setAttribute('aria-expanded', false);
            button.addEventListener('click', () => {
                const exp = button.getAttribute('aria-expanded');
                if (exp === 'false') {
                    button.setAttribute('aria-expanded', 'true');
                    button.parentElement.classList.add('SubNavL1-button--active');
                } else {
                    button.setAttribute('aria-expanded', 'false');
                    button.parentElement.classList.remove('SubNavL1-button--active');
                }
            });
        });
    }

})(window, document);
